// extracted by mini-css-extract-plugin
export var calendar = "TargetPlatformPicker-module__calendar___56gLj";
export var calendarContainer = "TargetPlatformPicker-module__calendarContainer___5EYm8";
export var dateLabel = "TargetPlatformPicker-module__dateLabel___GLtRb";
export var flex = "TargetPlatformPicker-module__flex___+siHf";
export var option = "TargetPlatformPicker-module__option___XVTs9";
export var optionTitle = "TargetPlatformPicker-module__optionTitle___xVvRT";
export var releaseDate = "TargetPlatformPicker-module__releaseDate___y3edz";
export var releaseDateColumn = "TargetPlatformPicker-module__releaseDateColumn___nAsKQ";